import { useNavigate } from "react-router-dom";
import MenuDialogBase from "./MenuDialogBase";
import { useApplicationConflictOfInterestMutation } from "../../../services/graphql/api";
import { getApplDetailParams } from "../../../util/functions";

export default function DialogConflictOfInterest({ menuItemAndClose }) {
    const params = getApplDetailParams();
    const navigate = useNavigate();

    const [apiCall, result] = useApplicationConflictOfInterestMutation();
    
    async function apiCallAndReturn(variables) {
        await apiCall(variables);
        navigate("/");
    }

    const variables = { ...params };
    const buttons = [{ label: "Report Conflict", variables }];

    return (
        <MenuDialogBase menuItemAndClose={menuItemAndClose}
            apiCall={apiCallAndReturn}
            buttons={buttons}
            result={result}
        />
    );
}